// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2RkCb","inner":"Footer_inner__Q_dMh","nextIcon":"Footer_nextIcon__1hp-M","innerLeft":"Footer_innerLeft__2x79h"};